const mapLocations = document.querySelector('.location-module__content');
if (mapLocations) {
  const radioButton = mapLocations.querySelectorAll('input[type=radio]');
  radioButton.forEach((radio) => {
    radio.addEventListener('click', (item) => {
      const showAll = item.target.id === 'all';
      const displayedPins = [];
      document.querySelectorAll('.location-table__inner tbody tr').forEach((row) => {
        const tableRow = row;
        tableRow.style.display = (tableRow.dataset.country === item.target.id || showAll) ? 'table-row' : 'none';
      });
      window.markers.forEach((marker) => {
        const showPin = (marker.country === item.target.id || showAll) ? 1 : 0;
        marker.marker.setOpacity(showPin);
        if (showPin) {
          // eslint-disable-next-line no-underscore-dangle
          displayedPins.push({lat: marker.marker._latlng.lat, lng: marker.marker._latlng.lng});
        }
      });
      if (displayedPins.length) {
        const latMin = Math.min(...displayedPins.map(pin => pin.lat));
        const latMax = Math.max(...displayedPins.map(pin => pin.lat));
        const lngMin = Math.min(...displayedPins.map(pin => pin.lng));
        const lngMax = Math.max(...displayedPins.map(pin => pin.lng));
        window.map.flyTo([(latMin+latMax)/2, (lngMin+lngMax)/2], showAll ? 5 : 6);
      }
    });
  });
}
